export const CATEGORY_IDS = {
  WEB_FUNDAMENTALS:  "web-fundamentals",
  REACT_STATE:       "react-state",
  TESTING_DEBUGGING: "testing-debugging",
  RESPONSIBLE_AI:    "responsible-ai",
};

export const categories = [
  {
    id: CATEGORY_IDS.WEB_FUNDAMENTALS,
    displayName: "Web Fundamentals",
    description: "HTML, JavaScript, and application structure",
  },
  {
    id: CATEGORY_IDS.REACT_STATE,
    displayName: "React and State",
    description: "Managing answers and changing interface state",
  },
  {
    id: CATEGORY_IDS.TESTING_DEBUGGING,
    displayName: "Testing and Debugging",
    description: "Finding errors and verifying generated code",
  },
  {
    id: CATEGORY_IDS.RESPONSIBLE_AI,
    displayName: "Responsible AI Coding",
    description: "Security, accessibility, Git, and AI reliability",
  },
];
